// Token addresses on Arbitrum
export const WETH_ADDRESS = '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1';
export const ORNE_TOKEN_ADDRESS = '0x89DbdB8e3b0e41aAe0871Bf9e1fcCe72F117bB1f';

// Uniswap V3 addresses
export const UNISWAP_V3_ROUTER = '0xE592427A0AEce92De3Edee1F18E0157C05861564';
export const UNISWAP_V3_QUOTER_V2 = '0x61fFE014bA17989E743c5F6cB21bF9697530B21e';

// Token symbols
export const WETH_SYMBOL = 'WETH';
export const ORNE_SYMBOL = 'ORNE';

// Token decimals
export const WETH_DECIMALS = 18;
export const ORNE_DECIMALS = 18; 